export type RevenueFilterFiled =
  | 'platform'
  | 'start_date'
  | 'time_interval'
  | 'monetization'
  | 'metric_type';

export type GameSegmentType =
  | 'soc'
  | 'shooter'
  | 'mmo'
  | 'rpg'
  | 'casual'
  | 'customize'
  | 'POE-like'
  | 'Tarkov-like'
  | 'Dying Light 2-Related'
  | 'Dune-related'
  | 'all';

export type TimeBasicType =
  | 'Earliest Date'
  | 'Release Date'
  | 'PC&Console Aligned by Earliest Date'
  | 'PC&Console Aligned by Release Date';

export type EntityType = 'mobile' | 'pc' | 'console' | 'all';
export type RevenueSegmentType =
  | 'us_digital_revenue'
  | 'business'
  | 'basic_info'
  | 'socail_channels';

export type RevenueValue = {
  [key in RevenueFilterFiled]: string[];
};

export type OperationLogType = 'searchLog' | 'buttonLog' | 'pageLog';

export interface RevenueOption {
  label: string;
  value: string;
  res?: string | string[];
}

export interface RevenueGroupItem {
  name: string;
  value: RevenueFilterFiled;
  option: RevenueOption[];
}

export interface BenchmarkGameOptions {
  value: string;
  text: string | React.ReactNode;
}

export interface SegmentOption {
  text: string;
  value: GameSegmentType;
  name?: string;
  info?: string;
}

export interface BenchmarkGameItem {
  id: string;
  entity_name: string;
  entity_type: EntityType;
  cover: string;
  release_time: string;
  company: string;
  company_country: string;
  is_customize: boolean;
  pc_id?: string;
  console_id?: string;
  platform?: ('mobile' | 'pc' | 'console')[];
}

export interface BenchmarkGameResponse {
  genre_type: GameSegmentType;
  list: BenchmarkGameItem[];
  total: number;
}

export type GameConfigType<T> = {
  [key in GameSegmentType]: T[];
};

export interface VidoeBenchmarkRankType {
  app_id: string;
  unified_id: string;
  entity_type: 'console';
  name: string;
  cover: string;
  genre: string;
  sub_genre: string;
  iegg_genre: string;
  iegg_sub_genre: string;
  markets: string;
  publisher: string;
  developer: string;
  newPublisher: string;
  publisher_addr: string;
  release_time: string;
  platform: string | null;
  sales_platform: string;
  other_name: string;
  rank: number;
  metric_list: MetricItem[];
  is_need_supplement: string;
  b_ogdb_data: boolean;
  metric_map: {
    [key: string]: MetricItem;
  };
}

export interface MetricItem {
  metric: string;
  title: string;
  value: string;
  order_metric: string;
  entity_type: EntityType;
  growth_ratio: string | null;
  order_source: string;
  b_predict: false;
  latest_time: string;
  history: string | null;
}

export interface VidoeBenchmarkRankResponse {
  rank_au_list: VidoeBenchmarkRankType[] | null;
  total: number;
}

export interface IMetricSelectMultipleCompValue {
  // 指标分类 key
  category: string;
  // 指标 key列表
  metrics: string[];
}

export interface FigureDataResponse {
  gas: {
    console: gasDataType[];
    pc: gasDataType[];
  };
  summary: FigureSummary;
  pc_players_by_country: PlayersCountryType[];
  trends: TrendsData;
}

export interface FigureSummary {
  country_info?: string[];
  revenue_trends?: string[];
  sales_trend?: string[];
  gas_ratio?: {
    console?: string[];
    pc?: string[];
  };
}

export interface gasDataType {
  type: 'console' | 'pc';
  value: number;
  dod: number;
  metric: string;
}

export interface PlayersCountryType {
  dod: number;
  metric: string;
  type: string;
  value: string;
}

export interface TrendsDataType {
  date: string;
  metrics: gasDataType[];
  total: number;
}

export interface TrendsData {
  revenue?: TrendsDataType[];
  unit?: TrendsDataType[];
}

export interface PieData {
  type: string;
  name: string;
  value: number | string;
}

export interface FigureData {
  countryPieData: PieData[];
  gasLinexAxis: string[];
  gasLineData: any[];
  summary: FigureSummary;
  trends?: {
    revenue?: any[];
    unit?: any[];
  };
  usRevenue: any[];
  retentionCurve: any[];
  arpuRetention: [];
}

export enum RenderType {
  VALUE_AND_RATIO, // 默认 值+环比
  VALUE_AND_RATIO_NOPOINT, // 默认 值+环比(环比没有小数据点，小于1大于0才有)
  GROWTH_ONLY, // 仅百分比
  VALUE_ONLY, // 仅数值
  GROWTH_AND_RATIO, // 百分比+环比
  RANK_AND_RATIO, // 名次和名次环比
  TEXT, // 文本
  PRICE, // 价格，0展示Free
}
